<template>
  <div class="app">
    <v-form>
      <v-row no-gutters align="center">
        <v-col cols="2">
          <v-radio-group dense v-model="tipoFiltro" column>
            <v-radio label="Data" :value="true" />
            <v-radio label="Minuto" :value="false" />
          </v-radio-group>
        </v-col>
        <v-col v-if="tipoFiltro" class="mt-6 pr-4" cols="3">
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col v-else class="mt-6 pr-4" cols="3">
          <v-text-field v-model="rangeMinutos" type="number" outlined dense label="Intervalo de minutos" oninput="if(this.value < 0) this.value = 0" />
        </v-col>

        <v-col class="mt-6 pl-4">
          <v-select
            v-model="form.filas"
            :items="queues"
            outlined
            multiple
            dense
            label="Filas"
            @change="gerarRequisicao"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.filas.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggle">
                <v-list-item-action>
                  <v-icon :color="form.filas.length > 0 ? 'indigo darken-4' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="1" style="display: flex; justify-content: space-around;">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-btn icon right color="#283593" v-bind="attrs" v-on="on" @click="refreshInfo"> -->
                <v-btn icon right color="#283593" v-bind="attrs" v-on="on" @click="gerarRequisicao">
                <v-icon fab>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Atualizar Monitor</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="#283593" fab>mdi-information-outline</v-icon>
            </template>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #037CD6;">&#9632;</span>Online</span></div>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #2C9437;">&#9632;</span>Disponível</span></div>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #D3201F;">&#9632;</span>Ocupado</span></div>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #FFB301;">&#9632;</span>Pausado</span></div>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #FB8C00;">&#9632;</span>Lig. em Espera</span></div>
            <div><span class="centralizaLegenda"><span class="quadradoLegenda" style="color: #C2C2C2;">&#9632; </span>Indisponível</span></div>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />

    <ExpansionPanel :arrayInfoQueues="itemsMenuExpansible" :showSkeleton="showSkeleton" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import layoutMonitorCallCenterStore from '../_store'
import monitorCallCenterHttpService from '../_services/monitorCallCenterHttpService'

import ExpansionPanel from './ExpansionPanel'
// import { ioInstance } from '../../../../../main'

export default {
  name: 'LayoutMonitorMain',
  components: { ExpansionPanel },
  data: () => ({
    timeToRefresh: 120000,
    datetimestart: new Date(),
    queues: [],
    tipoFiltro: true,
    rangeMinutos: '',
    itemsMenuExpansible: [],
    showSkeleton: false,
    intervalRequisitions: null,
    intervalVerifier: false,
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
      filas: [],
    },
    dateProps: {
      locale: 'pt-br',
      color: 'bluePcm',
    },
    timeProps: {
      color: 'bluePcm',
      scrollable: true,
      format: '24hr',
    },
    textProps: {
      dense: true,
      outlined: true,
    },
  }),

  computed: {
    ...mapGetters('layoutMonitorCallCenterStore', ['getFilas']),

    todasFilasSelecionadas() {
      return this.form.filas.length === this.queues.length
    },
    algumasFilasSelecionadas() {
      return this.form.filas.length > 0 && !this.todasFilasSelecionadas
    },
    icon() {
      if (this.todasFilasSelecionadas) return 'mdi-close-box'
      if (this.algumasFilasSelecionadas) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    registerVuexModule(this.$store, 'layoutMonitorCallCenterStore', layoutMonitorCallCenterStore)

    this.datetimestart.setHours(0)
    this.datetimestart.setMinutes(0)
    this.datetimestart.setSeconds(0)

    await this.listarFilas()

    this.queues = this.getFilas.map(fila => ({ text: fila.description, value: fila._id }))
  },

  beforeDestroy() {
    clearInterval(this.intervalRequisitions)
  },

  methods: {
    ...mapActions('layoutMonitorCallCenterStore', ['listarFilas']),
    
    // refreshInfo() {
    //   ioInstance.emit('refreshInfo')
    // },

    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },

    toggle() {
      this.$nextTick(() => {
        if (this.todasFilasSelecionadas) {
          this.form.filas.splice(0)
        } else {
          this.form.filas.splice(0)
          this.form.filas = this.queues.map(queue => queue.value)
        }
        this.gerarRequisicao()
      })
    },

    gerarRequisicao() {
      this.itemsMenuExpansible.splice(0)
      this.intervalVerifier = false
      this.gerar()
      clearInterval(this.intervalRequisitions)
      this.intervalRequisitions = setInterval(() => this.gerar(), this.timeToRefresh)
      // console.log(this.itemsMenuExpansible)
    },

    async gerar() {
      if (!this.intervalVerifier) {
        this.showSkeleton = true
      }
      var dataHoraInicio
      if (!this.tipoFiltro && this.rangeMinutos !== '') {
        dataHoraInicio = moment()
          .subtract(this.rangeMinutos, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss')
      } else {
        dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm:ss')
      }
      this.form.dataHoraInicio = dataHoraInicio
      this.form.dataHoraFim = moment().format('YYYY-MM-DD HH:mm:ss')

      // ERRO NO MONITOR CALL CENTER -> CORRIGIR AQUI
      if (this.form.filas.length > 0) {
        const response = await monitorCallCenterHttpService.getData(this.form)

          // console.log(response)
        response.data.forEach(fila => {
          const indexQueue = this.queues.findIndex(queue => queue.value === fila.fila_id)

          if (indexQueue !== -1) {
            if (this.itemsMenuExpansible.length === 0) {
              this.itemsMenuExpansible.push({
                ...fila,
                fila_description: this.queues[indexQueue].text,
              })
            } else {
              const indexItemsMenuExpansible = this.itemsMenuExpansible.findIndex(
                itemMenu => itemMenu.fila_id === fila.fila_id
              )

              if (indexItemsMenuExpansible !== -1) {
                this.itemsMenuExpansible.splice(indexItemsMenuExpansible, 1, {
                  ...fila,
                  fila_description: this.queues[indexQueue].text,
                })
              } else {
                this.itemsMenuExpansible.push({ ...fila, fila_description: this.queues[indexQueue].text })
              }
            }
          }
        })
        this.itemsMenuExpansible.splice(0, 1, this.itemsMenuExpansible[0])
      }
      this.showSkeleton = false
      this.intervalVerifier = true
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
.centralizaLegenda {
  display: flex; align-items: center; justify-items: center;
}
.quadradoLegenda {
  font-size: 35px; text-shadow: 1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff; margin-right: 4px;
}
</style>
